import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export const NoFlightOffer = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <div className='min-h-[calc(100dvh-150px-65px)] max-lg:min-h-[calc(100dvh-150px-65px)] px-20 py-10 flex flex-col gap-5'>
        <p className='text-2xl font-[MuseoSans900]'>{t('noFlightOffer.offers')}</p>
        <p className='text-lg font-[MuseoSansCyrl]'>{t('noFlightOffer.noOffersToDisplay')}</p>
      </div>
    </Fragment>
  );
};
